import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { TurbulenceSvgComponent } from './turbulence-legend/turbulence-legend-svg';

export const TURBULENCE_LEGEND: TwcLegendParams = {
  title: 'TURBULENCE',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: TurbulenceSvgComponent },
  legendComponent: TwcLegendComponent
};
